import about1 from './About 1.jpg';
import about2 from './About 2.jpg';
import about3 from './About 3.jpg';
import about4 from './About 4.jpg';

export default {
    about1, about2, about3, about4
}